import React, { Fragment, Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { every } from 'lodash';
import plural from 'pluralize';
import StartBrewModal from '~/containers/startBrewModal/startBrewModal';
import CloneLotsModal from '~/containers/cloneLotsModal/cloneLotsModal';
import CompleteLotsModal from '~/containers/completeLotsModal/completeLotsModal';
import RenderWithPermission from '~/containers/renderWithPermission/renderWithPermission';
import { permissions } from '../../utils/permissions';

const initialState = {
  isOpen: false,
  startBrewModalOpen: false,
  cloneLotsModalOpen: false,
  completeLotsModalOpen: false
};

export default class LotListActions extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  toggleModal = name => {
    this.setState({
      [`${name}Open`]: !this.state[`${name}Open`]
    });
  };

  onActionSuccess = () => {
    this.setState(initialState);
    this.props.refreshList();
  };

  renderStartBrewingLotItem = () => {
    const { selectedLots } = this.props;
    const allArePending = every(selectedLots, l => l.status === 'PENDING');

    return (
      allArePending && (
        <DropdownItem onClick={() => this.toggleModal('startBrewModal')}>
          Start brewing selected {plural('lot', selectedLots.length)}
        </DropdownItem>
      )
    );
  };

  renderCompleteAndPayDutyLotItem = () => {
    const { selectedLots } = this.props;
    const allAreInProgress = every(selectedLots, l => l.dutyPaid === false);

    return (
      allAreInProgress && (
        <RenderWithPermission permission={permissions.canCompleteLot}>
          <DropdownItem onClick={() => this.toggleModal('completeLotsModal')}>
            Complete and pay duty for selected {plural('lot', selectedLots.length)}
          </DropdownItem>
        </RenderWithPermission>
      )
    );
  };

  render() {
    const { selectedLots } = this.props;
    if (!selectedLots.length) {
      return null;
    }

    const { startBrewModalOpen, cloneLotsModalOpen, completeLotsModalOpen } = this.state;

    return (
      <Fragment>
        <ButtonDropdown className="ml3 input-height" isOpen={this.state.isOpen} toggle={this.onToggle}>
          <DropdownToggle caret>Actions</DropdownToggle>
          <DropdownMenu>
            {this.renderStartBrewingLotItem()}
            {this.renderCompleteAndPayDutyLotItem()}
            <DropdownItem onClick={() => this.toggleModal('cloneLotsModal')}>
              Clone selected {plural('lot', selectedLots.length)}
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
        <StartBrewModal
          lots={selectedLots}
          isOpen={startBrewModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('startBrewModal')}
          refetchQueries={['lots']}
        />
        <CloneLotsModal
          lots={selectedLots}
          isOpen={cloneLotsModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('cloneLotsModal')}
        />
        <CompleteLotsModal
          lots={selectedLots}
          isOpen={completeLotsModalOpen}
          onSuccess={this.onActionSuccess}
          refetchQueries={['lots']}
          onToggle={() => this.toggleModal('completeLotsModal')}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/lotListActions/lotListActions.jsx